import { useCallback } from "react"
import { PageKey, setActivePageState, setLoadingState } from "../../application/states/ui"
import { useAppDispatch } from "../../presentation/hooks/store-hooks"
import { toast, Bounce } from 'react-toastify';

type IAlertType = 'success' | 'error' | 'info' | 'warning'

export const useUIService = () => {
  const dispatch = useAppDispatch()

  const setActivePage = useCallback((data: {
    pageKey: PageKey
  }) => {
    dispatch(setActivePageState({
      activePage: data.pageKey
    }))
  }, [dispatch])

  const setAlert = useCallback((data: {
    type: IAlertType,
    message: string
  }) => {
    toast[data.type](data.message, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });
  }, [])

  const setLoading = useCallback((data: {
    loading: boolean,
    message?: string,
    id: string
  }) => {
    dispatch(setLoadingState({
      loading: data.loading,
      id: data.id,
      message: data.message
    }))
  }, [dispatch])

  const changeTitleAndMetaDesc = useCallback((data: {
    title: string,
    metaDesc: string
  }) => {
    document.title = data.title
    const metaDesc = document.querySelector('meta[name="description"]')
    metaDesc?.setAttribute('content', data.metaDesc)
  }, [])

  return {
    setActivePage,
    setAlert,
    setLoading,
    changeTitleAndMetaDesc
  }
}